import styled from 'styled-components';

export const ConnectorLine = styled.div(
  ({ theme }) => `
  width: 2px;
  height: ${theme.spacing[7]}px;
  background-color: ${theme.colors.surface.border.gray.normal};
`
);

export const StepCardWrapper = styled.div<{ isSelected?: boolean; isPlaceholder?: boolean; hasHighlight?: boolean }>(
  ({ theme, isSelected, isPlaceholder, hasHighlight }) => `
  background-color: ${
    hasHighlight
      ? theme.colors.interactive.background.primary.faded
      : isPlaceholder
      ? 'transparent'
      : theme.colors.surface.background.gray.subtle
  };
  border: ${isPlaceholder ? '2px dashed' : '1px solid'} ${
    isSelected
      ? theme.colors.interactive.border.primary.default
      : theme.colors.surface.border.gray.normal
  };
  border-radius: ${theme.border.radius.medium}px;
  padding: ${theme.spacing[4]}px ${theme.spacing[5]}px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  max-width: 400px;
  
  &:hover {
    border-color: ${theme.colors.interactive.border.primary.default};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
`
);

export const WorkflowContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
`;

export const SectionWrapper = styled.div<{ isNested?: boolean }>(
  ({ theme, isNested }) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  ${isNested ? `
    background-color: ${theme.colors.surface.background.gray.subtle};
    border: ${theme.border.width.thin}px solid ${theme.colors.surface.border.gray.normal};
    border-radius: ${theme.border.radius.medium}px;
    padding: ${theme.spacing[4]}px;
    margin-top: ${theme.spacing[2]}px;
  ` : ''}
`
);

export const DottedBackground = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${theme.spacing[8]}px;
  min-height: 100%;
  overflow-y: auto;
  background-color: ${theme.colors.surface.background.gray.moderate};
  background-image: radial-gradient(
    circle,
    ${theme.colors.surface.border.gray.muted} 1px,
    transparent 1px
  );
  background-size: ${theme.spacing[7]}px ${theme.spacing[7]}px;
  background-position: 0 0;
`
);
